import { useCallback } from "react";

export const normalizeCodeText = (value: string | null): string | null => {
    const trimmed = value?.trim() ?? "";
    return trimmed.length > 0 ? trimmed : null;
};

interface CodeTextFieldSetter {
    setFieldValue: (field: string, value: string | null) => void;
}

// Deliberately not normalizeCodeText: the field is controlled, so trimming on
// every keystroke feeds the trimmed value back into the input and makes a space
// impossible to type. Normalization happens at validation and payload build.
export const useChangeAccountCodeText = (formik: CodeTextFieldSetter) =>
    useCallback(
        (value: string) => {
            formik.setFieldValue("codeText", value === "" ? null : value);
        },
        [formik],
    );
